import { PrismicClient, linkResolver } from "../../shared/utils/prismicConfig"

const PrismicPreviewEndpoint = () => {
  PrismicClient.resolvePreviewURL({ linkResolver, defaultURL: "/" })
  return null
}

export default PrismicPreviewEndpoint
